<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Push Logistic Status </strong> 

          </div>
          <b-row>
           <b-col md="12" >
    
           <div>
            <ul class="nav nav-tabs nav-justified">
              <li class="nav-item">
                <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Logistic Details</a>
              </li>
             

              <li class="nav-item">
                <a @click="activeTab = 1"  class="nav-link" :class="{'active' : isActiveTab(1)}" >Push Undelivered Status</a>
              </li>

            </ul>
          </div>
           
          </b-col>
          <b-col md="12" >
        
            <div class="tab-panel" v-if="isActiveTab(0)">
              <logisticdetails style="width:70%;"></logisticdetails>
            </div>

            <div class="tab-panel" v-if="isActiveTab(1)">
            <logisticstatus style="width:70%;"></logisticstatus>
            </div>
            <documents v-if="isActiveTab(3)"></documents>
             </b-col>
          </b-row> 
        </b-card>
       
      </b-col>
    </b-row> 
  </div>   

</notassigned-component>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import logisticdetails from './logisticdetails.vue'
import logisticstatus from './logisticstatus.vue'


export default {
  data: function() {
    return {
      activeTab: 0,
      logisticdetails,
      logisticstatus,
      name: 'exceptionReport'
    };
  },
  components: {
    logisticdetails,
    logisticstatus,
  },
  created: function() {
    this.isActiveTab(0);
  },
  methods: {
    isActiveTab(id)
    {
       return this.activeTab === id
    }
  }
};
</script>
